import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {SelectItem} from 'primeng/api';
import {UntypedFormGroup} from '@angular/forms';
import {Subscription} from 'rxjs';
import {TranslateService} from '@ngx-translate/core';
import {OrganizationFeeCategoryService} from '../../services/oganization/organization-fee-category.service';

@Component({
  selector: 'wsd-select-fee-category',
  templateUrl: './select-fee-category.component.html',
  styleUrls: ['./select-fee-category.component.css']
})
export class SelectFeeCategoryComponent implements OnInit, OnDestroy {


  @Input()
  parentForm: UntypedFormGroup;

  @Input()
  label: string = 'SELECT_FEE_CATEGORY.LABEL';

  @Input()
  controlName: string = 'feeCategory';

  @Input()
  showPlaceholder: boolean = false;

  @Input()
  showLabel: boolean = false;

  feeCategories: SelectItem[] = [];

  private translateSubscription: Subscription;

  constructor(private translate: TranslateService,
              private organizationEventCategoryRestService: OrganizationFeeCategoryService) {
  }

  ngOnInit() {
    this.initValues();
    this.translateSubscription = this.translate.onDefaultLangChange.subscribe(
      (lang: any) => this.initValues()
    );
  }

  ngOnDestroy() {
    this.translateSubscription.unsubscribe();
  }

  private initValues() {
    if (!this.translate.getDefaultLang()) {
      return;
    }
    this.feeCategories = [];
    this.organizationEventCategoryRestService.getAllFeeCategories().subscribe(
      (data: any) => {
        for (const item of data) {
          this.feeCategories.push({
            label: item,
            value: item
          });
          if (this.parentForm.get(this.controlName) &&
            this.parentForm.get(this.controlName).value &&
            this.parentForm.get(this.controlName).value === item) {
            this.parentForm.get(this.controlName).setValue(item);
          }
        }
      }
    );
  }
}
